import { fetch } from '@maxtropy/components';

// ========== 报警记录接口类型定义 ==========

// 报警记录请求参数
export interface AlarmRecordRequest {
  page?: number;
  size?: number;
  timestamp?: number;
  ruleInfo?: string;
  alarmName?: string;
  startTime?: number;
  endTime?: number;
  levels?: number[];
  deviceName?: string;
  state?: string;
}

// 报警详情项
export interface AlarmDetailItem {
  id?: number;
  deviceId?: number;
  deviceCode?: string;
  deviceName?: string;
  alarmLevel?: number;
  alarmName?: string;
  state?: number;
  alarmCode?: string;
  alarmTime?: string;
  recoveryTime?: string;
  duration?: string;
}

// 报警记录响应数据
export interface AlarmRecordResponse {
  topLevel?: number;
  highLevel?: number;
  notRecovered?: number;
  recovered?: number;
  page?: number;
  size?: number;
  total?: number;
  details?: AlarmDetailItem[];
}

// 获取报警记录数据
export function getAlarmRecord(params: AlarmRecordRequest): Promise<AlarmRecordResponse> {
  return fetch(
    // `http://10.50.16.221:40001/mock/487/api/v2/h5/energy/overview/alarmRecord`,
    `/api/v2/h5/energy/overview/alarmRecord`,
    {
      method: 'POST',
      body: JSON.stringify(params),
    },
    true
  );
}
